export default {
  orange: "#c96c3a",
  purple: "#742f4b",
};
